import React from 'react';
import { ImageMaintenance } from '../../assets/images';
import { TranslationUtils } from '../../utils';
import '../../components/MaintenanceModal/MaintenanceModal.scss';

export const Maintenance: React.FC = () => {
    return (
        <div>
            <div className={'maintenance-divider'} />
            <ImageMaintenance className="early-checkout-modal-image" />
            <div className="early-checkout-modal-text">
                <br />
                <br />
                <h4>{TranslationUtils.get('maintenance_window_title')}</h4>
                <div className="mb-4" />
                <p>{TranslationUtils.get('maintenance_window_note')}</p>
            </div>
        </div>
    );
};
